

import React, { useEffect, useState } from "react";
import {
    Box,
    Card,
    CardMedia,
    CardContent,
    Typography,
    Button,
    Grid,
    Avatar,
    IconButton,
} from "@mui/material";
import { AccessTime, DoNotTouchRounded, Person } from "@mui/icons-material";
import LatestNewsImage from "../../../../../Assets/latestNewsImage.jpg"
import { FaRegUser } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../../ReduxStore/actions";
import { adminUrl } from "../../../../../constants";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";
// import { adminUrl } from "../../constants";



const RecentPosts = ({ recentPostDates, values, onClose, sectionNameForApproveAndReject }) => {


    const [responseData, setResponseData] = useState()

    console.log(values, "valuesssss")
    console.log(responseData, "responseDatattaatatatt")
    const TableId = useSelector((state) => state.Table.TableId);

    console.log(TableId, "TebleIddddd")

    const dispatch = useDispatch()

    useEffect(() => {
        console.log(TableId, "TebleIddddd111")

        if (TableId && !values) {
            console.log(TableId, "TebleIddddd222")

            const fetchData = async () => {
                const data1 = {
                    data: {},
                    method: "get",
                    apiName: `getBlogSectionById/${TableId}`,
                };
                const response = await dispatch(actions.GETBLOGSECTIONBYID(data1));

                console.log(response, "responseresponse")

                if (response?.payload?.message === "Blog section retrieved successfully.") {
                    console.log("hiiii")

                    setResponseData(response?.payload?.data)
                    // setUploadedFile({
                    //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
                    //     type: "img",
                    //     progress: 100,
                    // }
                    // )
                    // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
                }
            };
            fetchData();
        }

    }, []);


    const data = values ? values?.cards?.map((data) => ({
        banner: data?.image?.fileUrl,
        date: data?.card_date,
        title: data?.card_title,
        secondary_title: data?.cart_title_secondtext,
        content: data?.card_content
    })) : (responseData?.additional_data?.card_design?.map((data) => ({
        banner: data?.logo,
        title: data?.title,
        secondary_title: data?.cart_title_secondtext,
        date: data?.card_date,

        content: data?.content
    })))

    const data1 = recentPostDates?.[0]?.additional_data?.card_design || [
        {
            "banner": "uploads/images/uploadImage-1734597334354.png",
            "title": "local Allemagne",
            "secondary_title": "Discover the Golden Opportunity",
            // "date": "24 Jan 2024",
            "content": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
            // "primary_button_text": "Let’s Explore..."
        },
        {
            "banner": "uploads/images/uploadImage-1734597334354.png",
            "title": "local Allemagne",
            "secondary_title": "Discover the Golden Opportunity",
            // "date": "24 Jan 2024",
            "content": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
            // "primary_button_text": "Let’s Explore..."
        },
        {
            "banner": "uploads/images/uploadImage-1734597334354.png",
            "title": "local Allemagne",
            "secondary_title": "Discover the Golden Opportunity",
            // "date": "24 Jan 2024",
            "content": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
            // "primary_button_text": "Let’s Explore..."
        },
        {
            "banner": "uploads/images/uploadImage-1734597334354.png",
            "title": "local Allemagne",
            "secondary_title": "Discover the Golden Opportunity",
            // "date": "24 Jan 2024",
            "content": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
            // "primary_button_text": "Let’s Explore..."
        }
    ]
    return (
        <>
            <Box
            // sx={{ p: 3 }}
            >
                <Box sx={{ textAlign: "center", mb: 4, display: "flex", justifyContent: "center" }}>
                    {/* Header Section */}
                    <Box>
                        <Typography
                            variant="h3"
                            gutterBottom
                            sx={{ paddingBottom: "5px", maxWidth: "600px" }}
                        >
                            {responseData?.heading || values?.heading_title || "Default Heading"}
                            <span style={{ color: "black", fontWeight: "800" }}>  {responseData?.sub_heading || values?.heading_second_text || "Default Sub-heading"}</span>
                        </Typography>
                    </Box>
                </Box>
                {/* Main Content */}


                {/* Right Smaller Cards */}
                <Grid item xs={12} md={12}>
                    <Grid container spacing={4}>
                        {data?.map((item, index) => (
                            <Grid item xs={12} key={index}>
                                <Card sx={{
                                    display: { xs: "block", md: "flex", sm: "flex" }, p: 0, borderRadius: "0", boxShadow: "none"
                                    // height: "170px" 
                                }}>
                                    <CardMedia
                                        component="img"
                                        sx={{
                                            width: { xs: "100%", md: "275px", sm: "275px" },
                                            height: "270px",
                                            borderRadius: "10px"
                                        }}
                                        image={`${adminUrl}${item.banner}`} // Replace with actual image
                                        // image={LatestNewsImage} // Replace with actual image

                                        alt="Small Card Image"
                                    />
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between", // Ensures the content is spaced evenly
                                            alignItems: "flex-start", // Align content to the left
                                            // height: "170px",
                                            px: { sx: 0, xs: 2 },
                                            paddingBottom: 0, // Remove unnecessary padding
                                        }}
                                    >
                                        <Box pb={0} sx={{
                                            width: "100%",
                                            // height: "170px",

                                        }}>
                                            <Box display="flex" alignItems="center"
                                                sx={{ gap: { xs: 1, md: 2 } }} mb={1}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "#C38F51",
                                                        // fontSize: { xs: "10px", md: "14px" },

                                                    }}
                                                >
                                                    {/* <FaRegUser style={{ marginRight: "5px" }} /> */}
                                                    {item.title || "default title"}

                                                </Typography>

                                            </Box>
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    // fontSize: { xs: "12px", md: "16px" },
                                                    // fontWeight: { xs: "400", md: "700" },
                                                    mb: 1


                                                }}>
                                                {item.secondary_title || "default secondary_titles"}
                                            </Typography>
                                            <Typography variant="body1" color="text.secondary">
                                                <Box
                                                    sx={{
                                                        overflow: "hidden",
                                                        // width:"80%"
                                                        // maxHeight: { xs: "50%", md: "50px" },
                                                    }}
                                                >
                                                    {item.content || "default content"}

                                                </Box>

                                            </Typography>


                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>

            </Box>
            <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />
        </>
    );
};

export default RecentPosts;
